import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebaseConfig';
import { storeUrlForUA } from './LiveScoreView';

// Landing page for referral links: advancedbowlingtracker.com/r/{code}.
// Tries to open the app (universal link handles installed users before this
// page even renders; the custom scheme is the warm fallback), validates the
// code against the world-readable referralCodes registry, and routes
// non-users to the right store with the reward pitch.
export default function ReferralInterstitial({ code }) {
  const [state, setState] = useState('loading'); // loading | valid | invalid | error

  const upperCode = (code || '').toUpperCase();
  const customSchemeURL = `bowlingtracker://r/${upperCode}`;
  const storeUrl = storeUrlForUA(typeof navigator !== 'undefined' ? navigator.userAgent : '');

  useEffect(() => {
    window.location.href = customSchemeURL;

    async function validate() {
      try {
        const snapshot = await getDoc(doc(db, 'referralCodes', upperCode));
        setState(snapshot.exists() ? 'valid' : 'invalid');
      } catch (err) {
        setState('error');
      }
    }
    validate();
  }, [customSchemeURL, upperCode]);

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh', background: '#0a0e1a', color: '#fff', fontFamily: 'Inter, sans-serif',
      padding: '24px', textAlign: 'center',
    }}>
      <img src={process.env.PUBLIC_URL + '/favicon.png'} alt="ABT" style={{ width: 80, height: 80, borderRadius: 16, marginBottom: 24 }} />

      {state === 'loading' ? (
        <p style={{ fontSize: 15, color: '#999' }}>Loading your invite...</p>
      ) : state === 'invalid' ? (
        <>
          <h2 style={{ fontSize: 22, fontWeight: 700, margin: '0 0 8px' }}>Invite Not Found</h2>
          <p style={{ fontSize: 15, color: '#999', margin: '0 0 24px', maxWidth: 340 }}>
            This invite link is invalid. Ask your friend to send a new one, or just grab the app.
          </p>
          <a href={storeUrl} style={storeButtonStyle}>Get the App</a>
        </>
      ) : (
        <>
          <h2 style={{ fontSize: 22, fontWeight: 700, margin: '0 0 8px' }}>You've Been Invited</h2>
          <p style={{ fontSize: 15, color: '#ccc', margin: '0 0 6px', maxWidth: 340 }}>
            Download Advanced Bowling Tracker and get 1 month of Pro free after your first game.
          </p>
          <p style={{ fontSize: 13, color: '#777', margin: '0 0 24px', maxWidth: 340 }}>
            Open this link again once the app is installed and your invite applies automatically.
            Or enter code <span style={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace', fontWeight: 700, color: '#ccc', letterSpacing: 2 }}>{upperCode}</span> when the app asks.
          </p>
          <a href={storeUrl} style={storeButtonStyle}>Get the App</a>
          <a href={customSchemeURL} style={openButtonStyle}>I Already Have the App</a>
        </>
      )}
    </div>
  );
}

const storeButtonStyle = {
  display: 'inline-block', padding: '14px 32px', background: '#E53935', color: '#fff',
  borderRadius: 12, fontWeight: 600, fontSize: 16, textDecoration: 'none', marginBottom: 16,
};

const openButtonStyle = {
  display: 'inline-block', padding: '14px 32px', background: 'transparent', color: '#999',
  borderRadius: 12, fontWeight: 500, fontSize: 14, textDecoration: 'none',
  border: '1px solid #333',
};